<h1 style="margin-bottom: 1rem;">Clientes con saldo vencido</h1>
<p-chart type="bar" [data]="chartData" [options]="chartOptions" style="height: 500px;"></p-chart>